import React from 'react'
import { DateKey } from '../../types/DateKey'
import { styled } from '../../stitches/stitches.config'
import {
  toDayName,
  toDate,
  getDiffDays,
  formatDate,
  isUpdatedAtToday,
  getTodayKey,
} from '../../utils/date'
import { parse } from 'date-fns'

type Props = {
  selectedDateKey: DateKey
  hasPlace: boolean
}

const PageFeedContentTitle: React.FC<Props> = ({
  selectedDateKey,
  hasPlace,
}) => {
  const diffDaysWithToday = getDiffDays(
    new Date(toDate(selectedDateKey)),
    new Date()
  )
  const isUpdated = isUpdatedAtToday()
  const isTodayKey = getTodayKey() === selectedDateKey

  return (
    <>
      <TodayDate>{`${formatDate(
        parse(selectedDateKey, 'yyyy-MM-dd', new Date()),
        'MM월 dd일'
      )} ${toDayName(toDate(selectedDateKey).getDay())}요일${
        diffDaysWithToday === 0
          ? ' (오늘)'
          : diffDaysWithToday === 1
          ? ' (어제)'
          : ''
      }`}</TodayDate>
      <Noti>
        {hasPlace
          ? '새로 생긴 곳이 있어요'
          : isTodayKey && !isUpdated
          ? '곧 새로운 맛집이 올 거에요🍴'
          : `${isTodayKey ? '오늘은 ' : ''}새로 생긴 곳이 없어요`}
      </Noti>
    </>
  )
}

export default PageFeedContentTitle

const TodayDate = styled('div', {
  color: '$gray900',
  $text: 'label',
  fontWeight: 400,
})

const Noti = styled('div', {
  margin: '4px 0 0',
  color: 'black',
  $text: 'title',
})
